var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"controls"},[_c('button',{staticClass:"btn",class:{ skelly: !_vm.init },on:{"click":_vm.remove}},[_vm._v("←")]),_c('button',{staticClass:"btn",class:{ skelly: !_vm.init },on:{"click":_vm.shuffle}},[_vm._v("⤨")]),_c('button',{staticClass:"btn",class:{ skelly: !_vm.init },on:{"click":_vm.submit}},[_vm._v("↵")])])
}
var staticRenderFns = []

export { render, staticRenderFns }